import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import ErrorHandler from './Layout/ErrorHandler/ErrorHandler';
import MenuSidebar from './Layout/MenuSidebar/MenuSidebar';
import FleetListDetails from './Layout/DetailsSidebar/FleetListDetails';
import UserManagementListDetails from './Layout/DetailsSidebar/UserManagementListDetails';
import ManageUserDetails from './Layout/DetailsSidebar/ManageUserDetails';
import Map from './Map/_Map';
import CarReport from './Raports/CarReport';
import InstallationReport from './Raports/InstallationReport';
import ActiveTerminalsReport from './Raports/ActiveTerminalsReport';
import VehiclesStateReport from './Raports/VehiclesStateReport';
import * as Dictionary from '../Models/Dictionary';
import { EnumTypes as PageEnumTypes } from '../Models/EnumTypes/PageEnumTypes';
import * as UserModule from './../Modules/UserModule';
import * as ViewManagementModule from './../Modules/ViewManagementModule';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/pl';
import UserSigningRoot from './UserSigning/_UserSigningRoot';
import PasswordManagement from './Account/PasswordManagement/PasswordManagement';
import CarDetails from './Map/CarDetails/CarDetails';
import VehiclesList from './Map/VehiclesList/VehiclesList';
import POIManagement from './Map/POIManagement/PoiManagement';
import UserManagement from './UserManagement/UserManagement';
import CarsManagement from './CarsManagement/CarsManagement';
import CarDiagnostic from './CarsManagement/CarDiagnostic';
import CarHistory from './CarsManagement/CarHistory';
import FleetList from './Fleet/FleetList';
import AlertList from './Alerts/AlertList';
import AlertHistory from './Alerts/AlertHistory';
import CompositeLists from './Alerts/CompositeLists';
import ManageFleet from './Fleet/ManageFleet';
import ManageAlert from './Alerts/ManageAlert';
import AlertListDetails from './Layout/DetailsSidebar/AlertListDetails';
import ManageFleetDetails from './Layout/DetailsSidebar/ManageFleetDetails';
import ManageAlertDetails from './Layout/DetailsSidebar/ManageAlertDetails';
import CarMainReportDetails from './Layout/DetailsSidebar/CarMainReportDetails';
import TerminalInstallationReportDetails from './Layout/DetailsSidebar/TerminalInstallationReportDetails';
import ActiveTerminalsReportDetails from './Layout/DetailsSidebar/ActiveTerminalsReportDetails';
import CarPreviewDetails from './Layout/DetailsSidebar/CarPreviewDetails';
import ManageCarPreview from './Layout/DetailsSidebar/ManageCarPreview';
import DetailsSidebar from './Layout/DetailsSidebar/_DetailsSidebar';
import UserManagementAdd from 'components/UserManagement/UserManagementAdd';
import UserManagementEdit from 'components/UserManagement/UserManagementEdit';
import TerminalInstallation from './TerminalInstallation/TerminalInstallation';
import TerminalInstallationListDetails from './Layout/DetailsSidebar/TerminalInstallationListDetails';
import TerminalInstallationSetDateDetails from './Layout/DetailsSidebar/TerminalInstallationSetDateDetails';
import TerminalInstallationDetails from './Layout/DetailsSidebar/TerminalInstallationDetails';
import TerminalInstallationAdd from './TerminalInstallation/TerminalInstallationAdd';
import TerminalInstallationEdit from './TerminalInstallation/TerminalInstallationEdit';
import TerminalInstallationSetDate from './TerminalInstallation/TerminalInstallationSetDate';
import HistoryCollisionPage from './History/HistoryCollisionPage';
import CollisionListDetails from './Layout/DetailsSidebar/CollisionListDetails';
import HistoryCollisionPageWithToken, { HistoryCollisionPageWithTokenHOC } from './History/HistoryCollisionPageWithToken';
import DefaultPageWrapper from './Layout/DefaultPageWrapper';
import { RootState } from 'Redux/Reducers/_RootReducer';
import CollisionListPage from './History/CollisionListPage';
import CollisionDetails from './Layout/DetailsSidebar/CollisionDetails';
import VehiclesStateReportDetails from "components/Layout/DetailsSidebar/VehiclesStateReportDetails";
import TurnOffCar from "components/CarsManagement/TurnOffCar";
import TurnOffCarDetails from "components/CarsManagement/TurnOffCarDetails";
import ContractList from "components/Contract/ContractList";
import ContractListDetails from "components/Layout/DetailsSidebar/ContractListDetails";
import ChangeOffDate from "components/Contract/ChangeOffDate";
import SimpleFormSendDetails from "components/Contract/SimpleFormSendDetails";
import EditContract from "components/Contract/EditContract";
import TechnicalBreakView from "Modules/TechnicalBreak/View/TechnicalBreak.View";
import CarRouteViewer from 'src/Modules/CarRouteViewer/Views/CarRouteViewer';
import MaintenanceBanner from './MaintenanceBanner/MaintenanceBanner.Component';
import SurveyBanner from './SurveyBanner/SurveyBanner.Component';
import MigrationModal from './MigrationModal/MigrationModal.Component';
import MigrationInfoBanner from './MigrationInfoBanner/MigrationInfoBanner.Component';
import { hasMigrationToken, isMigrationExcluded } from './MigrationModal/Services/migrationLogin.Service';

const MiddleBlock = (props: { title: string }) => (
       <div className="middleBlock">
              <h1>{props.title}</h1>
       </div>
);
const Loader = () => (
       <div className="loader">
              <div className="loader__inner" />
       </div>
);

const PublicHistoryCollisionPage = HistoryCollisionPageWithTokenHOC(HistoryCollisionPageWithToken);

export type Props = {
       history: any;
       location: any;
};
export type ConnectedProps = {
       token: string;
       user: UserModule.Types.UserDto;
       userRole: UserModule.UserEnumTypes.RoleName;
       activeLanguage: any;
       noActiveUser: any;
};
export type DispatchedProps = {
       initializeActivePage: (page: ViewManagementModule.Types.Page) => void;
       showLoader: () => void;
       hideLoader: () => void;
       checkUserLogin: () => void;
};

class App extends React.PureComponent<Props & DispatchedProps & ConnectedProps, any> {
       constructor(props: Props & DispatchedProps & ConnectedProps) {
              super(props);
              this.initActivePage = this.initActivePage.bind(this);
              this.props.checkUserLogin();
       }

       public initActivePage() {
              const URL = this.props.location.pathname;
              const name = URL.split('/');
              const currentPageName = Dictionary.PageUrlReverse.get(`/${name[1]}`);
              moment.defineLocale(this.props.activeLanguage, null);
              if (currentPageName) {
                     const currentPageDetails = Dictionary.PageDetails.get(currentPageName);
                     this.props.initializeActivePage(currentPageDetails);
              }
       }

       public isExternal() {
              return this.props.userRole === UserModule.UserEnumTypes.RoleName.EXTERNAL
       }


       public componentDidMount() {
              this.initActivePage();
       }

       public componentDidUpdate(prevProps: Readonly<Props & DispatchedProps & ConnectedProps>) {
              if (prevProps.userRole !== this.props.userRole
                     && this.isExternal()
                     && !this.props.location.pathname.includes(Dictionary.PageUrl.get(ViewManagementModule.EnumTypes.Page.TERMINAL_INSTALLATION))
              ) {
                     this.props.history.push(Dictionary.PageUrl.get(ViewManagementModule.EnumTypes.Page.TERMINAL_INSTALLATION));
              }
       }

       private renderCommonMainRoutes() {
              return [
                     // tslint:disable:jsx-key
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.MAP)} component={Map} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.ZONES)} component={Map} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.FLEET)} component={FleetList} />,
                     <Route exact path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.FLEET)}/add`}
                            component={ManageFleet} />,
                     <Route exact path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.FLEET)}/:fleetId`}
                            component={ManageFleet} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.ALERTS)} component={AlertList} />,
                     <Route exact path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.ALERTS)}/add`}
                            component={ManageAlert} />,
                     <Route exact path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.ALERTS)}/:alertId`}
                            component={ManageAlert} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.CONTRACTORS)}
                            component={() => <MiddleBlock title={'Kontrahenci'} />} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.USERS)}
                            component={() => <MiddleBlock title={'Użytkownicy'} />} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.MESSAGES)}
                            component={() => <MiddleBlock title={'Wiadomości'} />} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.SETTINGS)}
                            component={() => <MiddleBlock title={'Ustawienia'} />} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.CARRAPORT)} component={CarReport} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.INSTALLATION_REPORT)}
                            component={InstallationReport} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.FLEETRAPORT)}
                            component={() => <MiddleBlock title={'FLEETRAPORT'} />} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.DRIVERRAPORT)}
                            component={() => <MiddleBlock title={'DRIVERRAPORT'} />} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.MANUAL)}
                            component={() => <MiddleBlock title={'Instrukcja obsługi'} />} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.PASSWORD_MANAGEMENT)}
                            component={PasswordManagement} />,
                     <Route exact
                            path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.COLLISION_WITH_TOKEN)}/:collisionToken`}
                            component={HistoryCollisionPageWithToken} />,
                     <Route exact
                            path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.CAR_ROUTE_VIEWER)}/:token`}
                            component={CarRouteViewer} />
              ]
       }

       private renderAdminMainRoutes() {
              return [
                     <Route exact
                            path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.USER_MANAGEMENT)}/add`}
                            component={UserManagementAdd} />,
                     <Route exact
                            path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.USER_MANAGEMENT)}/:userId`}
                            component={UserManagementEdit} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.USER_MANAGEMENT)}
                            component={UserManagement} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.CARS_MANAGEMENT)}
                            component={CarsManagement} />,
                     <Route exact
                            path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.CARS_MANAGEMENT)}/:carId/diagnostic`}
                            component={CarDiagnostic} />,
                     <Route exact
                            path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.CARS_MANAGEMENT)}/:carId/history`}
                            component={CarHistory} />,
                     <Route exact
                            path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.CARS_MANAGEMENT)}/:carId/alert`}
                            component={AlertHistory} />,
                     <Route exact
                            path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.CARS_MANAGEMENT)}/:carId/turnOffCar`}
                            component={TurnOffCar} />,
                     <Route exact
                            path={Dictionary.PageUrl.get(PageEnumTypes.Page.ACTIVE_TERMINALS_REPORT)}
                            component={ActiveTerminalsReport} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.VEHICLES_STATE_REPORT)}
                            component={VehiclesStateReport} />,
                     <Route exact
                            path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.COLLISION)}/:collisionId`}
                            component={HistoryCollisionPage} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.COLLISION)}
                            component={CollisionListPage} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.CONTRACT_MANAGEMENT)}
                            component={ContractList} />,
                     <Route exact
                            path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.CONTRACT_MANAGEMENT)}/:contractId/change-off-date`}
                            component={ChangeOffDate} />,
                     <Route exact
                            path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.CARS_MANAGEMENT)}/:contractId/edit-contract`}
                            component={EditContract} />
              ]
       }

       private renderAdminAndExternalMainRoutes() {
              return [
                     <Route exact
                            path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.TERMINAL_INSTALLATION)}/add`}
                            component={TerminalInstallationAdd} />,
                     <Route
                            exact
                            path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.TERMINAL_INSTALLATION)}/:terminalInstallationId/installation-date`}
                            component={TerminalInstallationSetDate}
                     />,
                     <Route exact
                            path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.TERMINAL_INSTALLATION)}/:terminalInstallationId`}
                            component={TerminalInstallationEdit} />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.TERMINAL_INSTALLATION)}
                            component={TerminalInstallation} />
              ]
       }

       private renderForEveryoneExcludingExternalSidebarRoutes() {
              return [<Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.MAP)} component={CarDetails} />,
              <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.ZONES)}
                     component={POIManagement} />,
              <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.FLEET)}
                     component={FleetListDetails} />,
              <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.USER_MANAGEMENT)}
                     component={UserManagementListDetails} />,
              <Route exact path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.USER_MANAGEMENT)}/:userId`}
                     component={ManageUserDetails} />,
              <Route exact path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.FLEET)}/:fleetId`}
                     component={ManageFleetDetails} />,
              <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.ALERTS)}
                     component={AlertListDetails} />,
              <Route exact path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.ALERTS)}/:alertId`}
                     component={ManageAlertDetails} />,
              <Route exact path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.CARRAPORT)}`}
                     component={CarMainReportDetails} />,
              <Route exact path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.INSTALLATION_REPORT)}`}
                     component={TerminalInstallationReportDetails} />,
              <Route exact path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.ACTIVE_TERMINALS_REPORT)}`}
                     component={ActiveTerminalsReportDetails} />,
              <Route exact path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.VEHICLES_STATE_REPORT)}`}
                     component={VehiclesStateReportDetails} />,
              <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.CARS_MANAGEMENT)}
                     component={CarPreviewDetails} />,
              <Route exact
                     path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.CARS_MANAGEMENT)}/:carId/diagnostic`}
                     component={ManageCarPreview} />,
              <Route exact
                     path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.CARS_MANAGEMENT)}/:carId/history`}
                     component={ManageCarPreview} />,
              <Route exact
                     path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.CARS_MANAGEMENT)}/:carId/alert`}
                     component={ManageCarPreview} />,
              <Route exact
                     path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.CARS_MANAGEMENT)}/:carId/turnOffCar`}
                     component={TurnOffCarDetails} />,
              <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.COLLISION)}
                     component={CollisionListDetails} />,
              <Route exact path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.COLLISION)}/:collisionId`}
                     component={CollisionDetails} />,
              <Route exact
                     path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.COLLISION_WITH_TOKEN)}/:collisionToken`}
                     component={CollisionDetails} />,
              <Route exact
                     path={Dictionary.PageUrl.get(PageEnumTypes.Page.CONTRACT_MANAGEMENT)}
                     component={ContractListDetails} />,
              <Route exact
                     path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.CONTRACT_MANAGEMENT)}/:contractId/change-off-date`}
                     render={(props) => <SimpleFormSendDetails {...props} formName={'ChangeDateForm'} />} />,
              <Route exact
                     path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.CARS_MANAGEMENT)}/:contractId/edit-contract`}
                     render={(props) => <SimpleFormSendDetails {...props} formName={'editContractForm'} />} />,
              <Route exact
                     path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.TERMINAL_INSTALLATION)}/add`}
                     component={TerminalInstallationDetails} />,
              <Route exact
                     path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.TERMINAL_INSTALLATION)}/:terminalInstallationId`}
                     component={TerminalInstallationDetails} />
              ]
       }

       private renderCommonSidebarRoutes() {
              return [
                     <Route
                            exact
                            path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.TERMINAL_INSTALLATION)}/:terminalInstallationId/installation-date`}
                            component={TerminalInstallationSetDateDetails}
                     />,
                     <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.TERMINAL_INSTALLATION)}
                            component={TerminalInstallationListDetails} />
              ]
       }
       public render() {
              // Staly podglad modalu migracji do pracy nad wygladem (bez logowania, bez przekierowania).
              if (this.props.location && this.props.location.pathname === '/migration-preview') {
                     return <MigrationModal preview={true} />;
              }
              const { user, noActiveUser, token, userRole } = this.props;
              const isAdmin = userRole === UserModule.UserEnumTypes.RoleName.ADMIN
              const isExternal = userRole === UserModule.UserEnumTypes.RoleName.EXTERNAL
              const isAdminOrExternal = isAdmin || isExternal
              if (token && user.firstName) {
                     // Usera z kontem 2.0 przenosimy automatycznie (widzi wylacznie modal) - Z WYJATKIEM
                     // domen wewnetrznych oraz ADMIN-ow, ktorzy zostaja na 1.0 i dostaja tylko pasek
                     // z przyciskiem do 2.0 (przejscie opcjonalne, nie wymuszone).
                     if (hasMigrationToken() && !isMigrationExcluded(user.email) && !isAdmin) {
                            return <MigrationModal />;
                     }

                     return (
                            <>
                            <MaintenanceBanner />
                            <MigrationInfoBanner email={user.email} isAdmin={isAdmin} />
                            {/* <SurveyBanner /> */}
                            <DefaultPageWrapper>
                                   <MenuSidebar />
                                   <Switch>
                                          {!isExternal && this.renderCommonMainRoutes()}
                                          {isAdmin && this.renderAdminMainRoutes()}
                                          {isAdminOrExternal && this.renderAdminAndExternalMainRoutes()}
                                          <Route
                                                 component={() => {
                                                        this.props.history.push('/');
                                                        return null;
                                                 }}
                                          />
                                   </Switch>

                                   <DetailsSidebar showUI={true}>
                                          <Switch>
                                                 {!isExternal && this.renderForEveryoneExcludingExternalSidebarRoutes()}
                                                 {this.renderCommonSidebarRoutes()}
                                          </Switch>
                                   </DetailsSidebar>

                                   {!isExternal && (
                                          <Switch>
                                                 <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.MAP)} component={VehiclesList} />
                                                 <Route exact path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.FLEET)}/add`}
                                                        component={VehiclesList} />
                                                 <Route exact path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.FLEET)}/:fleetId`}
                                                        component={VehiclesList} />
                                                 <Route exact path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.ALERTS)}/:alertId`}
                                                        component={CompositeLists} />
                                                 <Route exact path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.ALERTS)}/:add`}
                                                        component={CompositeLists} />
                                                 <Route exact path={Dictionary.PageUrl.get(PageEnumTypes.Page.CARRAPORT)}
                                                        component={VehiclesList} />
                                          </Switch>
                                   )}

                            </DefaultPageWrapper>
                            </>
                     );
              } else if (noActiveUser) {
                     return (
                            <>
                                   <ErrorHandler />
                                   <MaintenanceBanner />
                                   <Switch>
                                          <Route exact
                                                 path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.COLLISION_WITH_TOKEN)}/:collisionToken`}
                                                 component={PublicHistoryCollisionPage} />
                                          <Route exact
                                                 path={`${Dictionary.PageUrl.get(PageEnumTypes.Page.CAR_ROUTE_VIEWER)}/:token`}
                                                 render={(props) => <CarRouteViewer {...props} noActiveUser={noActiveUser} />} />
                                          <Route path={'/'} component={UserSigningRoot} />
                                   </Switch>
                            </>
                     );
              } else {
                     return (
                            <>
                                   <ErrorHandler />
                                   <MaintenanceBanner />
                                   <Loader />
                            </>
                     );
              }
       }
}

function mapStateToProps(state: RootState): ConnectedProps {
       return {
              token: state.userStore.token,
              user: state.userStore.user,
              userRole: state.userStore.user?.roleName,
              // detailsPanelVisible: state.viewManagementStore.detailsPanelVisible,
              // vehicleListVisible: state.viewManagementStore.vehicleListVisible,
              // sidebarMenuExpanded: state.viewManagementStore.sidebarMenuExpanded,
              // activePage: state.viewManagementStore.activePage,
              // loaderVisible: state.viewManagementStore.loaderVisible,
              activeLanguage: state.viewManagementStore.activeLanguage,
              noActiveUser: state.userStore.noActiveUser
       };
}

function mapDispachToProps(dispatch: any): DispatchedProps {
       return {
              initializeActivePage: (page: ViewManagementModule.Types.Page) => dispatch(ViewManagementModule.Actions.setActivePage(page)),
              checkUserLogin: () => dispatch(UserModule.Actions.checkUser()),
              showLoader: () => dispatch(ViewManagementModule.Actions.showLoader()),
              hideLoader: () => dispatch(ViewManagementModule.Actions.hideLoader())
       };
}

export default connect(
       mapStateToProps,
       mapDispachToProps
)(App);



// WEBPACK FOOTER //
// ./src/components/_App.tsx